import * as React from 'react';
import AlertBox from '@reverbdotcom/commons/dist/components/alert_box';
import CoreLink from '@reverbdotcom/commons/dist/components/core_link';
import { I18N } from '@reverbdotcom/commons/dist/components/translate';
import { useHelpCenterSectionUrl } from '@reverbdotcom/commons/dist/url_helpers';
import { experimentBucket } from '@reverbdotcom/commons/dist/user_context_helpers';
import experiments from '@reverbdotcom/commons/dist/experiments';
import { useUser } from '@reverbdotcom/commons/dist/user_hooks';
import { EXPERIMENT_VALUES } from './shared/constants';
import { trackEvent, MParticleEventName } from '@reverbdotcom/commons/dist/elog/mparticle_tracker';
import { formatExperimentsForEventAttributes } from '@reverbdotcom/commons/dist/elog/mparticle';

export function CheckoutTaxCallout(props: { isUSMarketplaceTax: boolean }) {
  const helpCenterUrl = useHelpCenterSectionUrl('360009553954');
  const user = useUser();
  const bucket = experimentBucket(user, experiments.HIDE_WHATS_THE_TAX_TEXT_US);

  if (props.isUSMarketplaceTax && bucket && bucket !== EXPERIMENT_VALUES.CTL) {
    return null;
  }

  const body = props.isUSMarketplaceTax ?
    'discovery.checkout.taxNotification.usaBody' : 'discovery.checkout.taxNotification.internationalBody';

  return (
    <div>
      <AlertBox color="gray">
        <p className="weight-bold mb-1">
          <I18N text="discovery.checkout.taxNotification.heading" />
        </p>
        <p className="mb-1">
          <I18N text="discovery.checkout.taxNotification.subheading" />
        </p>
        <p className="mb-half">
          <span className="mr-space">
            <I18N data-callout-body text={body} />
          </span>
          <CoreLink data-tax-callout-link to={helpCenterUrl} onClick={() => trackClickLink(user)} target="_blank">
            <I18N text="discovery.checkout.taxLabel.tooltip.learnMore" />
          </CoreLink>
        </p>
      </AlertBox>
    </div>
  );
}

function trackClickLink(user) {
  trackEvent({
    eventName: MParticleEventName.ClickedCheckoutTaxHelpCenterLink,
    experiments: formatExperimentsForEventAttributes(user, [
      experiments.HIDE_WHATS_THE_TAX_TEXT_US,
    ]),
  });
}



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/components/checkout_tax_callout.tsx